<template lang="pug">
  v-card.mb-3
    .list-mobile__top(:class="{'list-mobile__top--offset-sm': isOpen}")
      .list-mobile__title.list-mobile__title--size-lg {{ item.name | shortstr }}
      .list-mobile__actions
        div(v-if="item.is_adjustment_leftovers")
          svg.leftovers-mark-icon
            use(:xlink:href="`/svg/sprite.svg#icon-leftovers`")
        ration-settings-dropdown(
          v-if="!isConsultant"
          :item="item"
          @close="$emit('update')"
          @on-copy="openCreateRationCopy"
          @on-load="openScheduleLoadDialog"
          @on-upload="openScheduleUploadDialog")
        v-btn(
          icon
          @click="toggle")
          template(
            v-if="isOpen")
            v-icon(
              font-size="1"
              icon="chevron-up")
          template(
            v-else)
            v-icon(
              font-size="1"
              icon="chevron-down")
    transition(name="fade")
      template(v-if="!isOpen")
        .list-mobile__content.list-mobile__content--offset-right
          .list-mobile__group.mb-1
            .list-mobile__group-label.mb-1 {{ 'base.animal_groups' | translate }}
            .list-mobile__group-value {{ groupsListLabel(item.schedule_groups) }}
          .list-mobile__item.list-mobile__item--no-border
            .list-mobile__item-label.list-mobile__item-label--color-black {{ 'base.weight_per_head' | translate }}
            .list-mobile__item-value {{ totalPerHeadWeight ? totalPerHeadWeight.toFixed(2) : '-' }} {{ 'base.kg' | translate }}
          .list-mobile__item.list-mobile__item--no-border
            .list-mobile__item-label.list-mobile__item-label--color-black  {{ 'base.load_weight' | translate }}
            .list-mobile__item-value {{ totalWeight | rounding }} {{ 'base.kg' | translate }}
          .list-mobile__item.list-mobile__item--no-border.mt-1
            .list-mobile__status(:class="statusLabel") {{ `status.${item.status}` | translate }}
            ui-number-input(
              medium
              line
              :min="1"
              :decimalPlaces="1"
              postfix=" %"
              v-model="item.coefficient"
              @input="update")
      template(v-else)
        div
          .list-mobile__status.ml-1.mb-2(:class="statusLabel") {{ `status.${item.status}` | translate }}
          v-divider(thin)
          .list-mobile__content.list-mobile__content--offset-sm
            .list-mobile__item.list-mobile__item--no-border.list-mobile__item--offset-sm
              .list-mobile__item-label.list-mobile__item-label--color-black(:class="{'mt-1': isConsultant}") {{ 'base.groups' | translate }}
              v-btn.mr-n1(
                v-if="!isConsultant"
                icon
                :loading="loading"
                @click="onClick")
                v-icon(
                  font-size="1"
                  icon="plus")
              v-dialog(
                max-width="380"
                v-model="modals.showAddGroups")
                add-groups-modal(
                  :items="item.schedule_groups"
                  @close="modals.showAddGroups = false"
                  @on-add="addGroups")
            .list-mobile__section(
              v-for="group in item.schedule_groups"
              :key="group.id")
              .list-mobile__item
                .list-mobile__title.list-mobile__title--size-lg {{ 'base.animal_groups' | translate }} {{ group.name }}
                .list-mobile__title.list-mobile__title--size-lg {{ group.animal_count | rounding }} {{ 'base.heads' | translate }}
              .list-mobile__item.list-mobile__item--no-border
                .list-mobile__item-label.list-mobile__item-label--color-black {{ 'base.weight_per_head' | translate }}
                .list-mobile__item-value {{ weightPerHead(group) }} {{ 'base.kg' | translate }}
              .list-mobile__item.list-mobile__item--no-border
                .list-mobile__item-label.list-mobile__item-label--color-black {{ 'base.load_weight' | translate }} {{ 'base.kg' | translate }}
                .list-mobile__item-value 
                  .value
                    input.input-number(
                      type="number",
                      name="planWeight",
                      id="planWeight",
                      v-model="group.plan_weight"
                      @change="update"
                    )
              .list-mobile__item.list-mobile__item--no-border
                .list-mobile__item-label.list-mobile__item-label--color-black
                .list-mobile__item-value
                  ui-number-input(
                    :min="1"
                    :decimalPlaces="1"
                    :max="500"
                    postfix="%"
                    v-model="group.coefficient"
                    @click.native.stop=""
                    @input="onUpdate(item)"
                  )
          v-divider.mb-2(thin)
          .list-mobile__content
            .list-mobile__item.list-mobile__item--no-border.list-mobile__item--offset-sm
              .list-mobile__item-label.list-mobile__item-label--color-black {{ 'base.ration' | translate }}
            v-select.m-none.pr-2(
              :disabled="isConsultant"
              :title="'base.ration' | translate"
              :options="rationsList"
              v-model="ration.id")
              .list-mobile__item-value {{ totalPerHeadWeight | rounding }} {{ 'base.kg' | translate }}
            .list-mobile__item.list-mobile__item--no-border
              .list-mobile__item-label.list-mobile__item-label--color-black {{ 'base.load_weight' | translate }}
              .list-mobile__item-value {{ totalWeight | rounding }} {{ 'base.kg' | translate }}
          v-divider.mb-2(thin)
          .list-mobile__content
            .list-mobile__item.list-mobile__item--no-border.list-mobile__item--offset-sm
              .list-mobile__item-label.list-mobile__item-label--color-black {{ 'base.mixer' | translate }}
            v-select.m-none.pr-2(
              :disabled="isConsultant"
              :title="'base.mixer' | translate" 
              :options="mixers"
              v-model="mixer.id")
            .list-mobile__item.list-mobile__item--no-border
              .list-mobile__item-label.list-mobile__item-label--color-black {{ 'base.mix_time' | translate }}
              .list-mobile__item-value
                ui-number-input(
                  :value="Math.floor(item.mix_time / 60)"
                  @input="updateMixTime($event)"
                  :postfix="'base.min' | translate"
                )

    v-dialog(
      v-model="showScheduleUploadDialog")
      schedule-upload-dialog(
        :item="item"
        @on-close="closeScheduleUploadDialog")
    
    v-dialog(
      v-model="showScheduleLoadDialog")
      schedule-load-dialog(
        :item="item"
        @on-close="closeScheduleLoadDialog")

    v-dialog(
      max-width="350"
      v-model="modals.showCreateRationCopy")
      create-ration-copy-modal(
        :ration-id="item.id"
        @update="update"
        @close="closeCreateRationCopy")
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'
import { round } from '@/util'

import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput.vue'

import RationSettingsDropdown from './dialogs/RationSettingsDropdown'
import AddGroupsModal from './dialogs/AddGroupsModal'
import CreateRationCopyModal from './dialogs/CreateRationCopyModal'
import ScheduleLoadDialog from './dialogs/ScheduleLoadDialog.vue'
import ScheduleUploadDialog from './dialogs/ScheduleUploadDialog.vue'

const animalCountReducer = (acc, item) => (acc += item.animal_count)
const totalWeightReducer = (acc, item) => (acc += item.plan_weight)
const totalPerHeadWeight = (acc, item) => (acc += item.plan_weight / item.animal_count)

export default {
  name: 'PlanningItemMobile',

  components: {
    UiNumberInput,
    AddGroupsModal,
    RationSettingsDropdown,
    CreateRationCopyModal,
    ScheduleLoadDialog,
    ScheduleUploadDialog
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    modals: {
      showAddGroups: false,
      showCreateRationCopy: false
    },
    showScheduleLoadDialog: false,
    showScheduleUploadDialog: false,
    isOpen: false,
    ration: {
      id: '',
      name: '',
    },
    mixer: {
      id: '',
      name: '',
    },
    mixers: [],
    hasChanges: false,
    loading: false
  }),

  computed: {
    ...mapGetters('rations', [
      'rationsList'
    ]),

    statusLabel () {
      return {
        'list-mobile__status--waited': this.item.status === 'waited',
        'list-mobile__status--loaded': this.item.status === 'loaded',
        'list-mobile__status--uploaded': this.item.status === 'uploaded',
        'list-mobile__status--in-process': this.item.status === 'in_process',
        'list-mobile__status--out-process': this.item.status === 'out_process',
      }
    },

    animalCount () {
      return this.item.schedule_groups
        .reduce(animalCountReducer, 0)
    },

    totalWeight () {
      return this.item.schedule_groups
        .reduce(totalWeightReducer, 0)
    },

    totalPerHeadWeight () {
      return this.item.schedule_groups
        .reduce(totalPerHeadWeight, 0)
    }
  },

  methods: {
    ...mapActions('mixers', [
      'loadMixersList'
    ]),

    ...mapActions('rations', [
      'loadRationsList'
    ]),

    ...mapActions('groups', [
      'loadGroupsList'
    ]),

    async loadData () {
      const filters = {
        farm: this.$route.params.farm_id,
        deleted: 'false'
      }
      await this.loadRationsList(filters)
      this.mixers = await this.loadMixersList(filters)

      this.mixer = {
        id: this.item.schedule_mixer.mixer,
        name: this.item.schedule_mixer.name,
        max_weight: this.item.schedule_mixer.max_weight
      }
      this.ration = {
        id: this.item.schedule_ration.ration,
        name: this.item.schedule_ration.name,
        ingredients: this.item.schedule_ration.ingredients
      }
    },

    async loadGroups () {
      const filters = {
        farm: this.$route.params.farm_id,
        deleted: 'false'
      }
      await this.loadGroupsList(filters)
    },

    async onClick () {
      this.loading = true
      await this.loadGroups()
      this.loading = false
      this.modals.showAddGroups = true
    },

    toggle () {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.loadData()
      }
    },

    groupsListLabel (items) {
      let str = ''
      if (items) {
        for (let i = 0; i < items.length; i++) {
          str += items[i].name
          if (i < items.length - 1) {
            str += ', '
          }
        }
      }
      return str.length > 22 ? str.substring(0, 23) + '...' : str
    },

    updateMixTime (event) {
      this.item.mix_time = event * 60
      this.update()
    },

    addGroups (groups) {
      for (let g of groups) {
        let res = this.item.schedule_groups.filter((item) => {
          return item.group === g.group
        })
        if (!res.length) {
          this.item.schedule_groups.push(g)
        }
      }
      this.sortGroups()
      this.hasChanges = true
      this.$emit('update')
    },

    sortGroups () {
      this.item.schedule_groups.forEach((element, index) => {
        element.ordering = index + 1
      })
    },

    async update () {
      await api.schedule.updateById(this.item.id, this.item)
      this.$emit('update')
    },

    weightPerHead (item) {
      const value = (item.plan_weight / item.animal_count)
      return !isNaN(value)
        ? round(value)
        : '-'
    },

    planWeight (item) {
      const value = item.plan_weight
      return !isNaN(value)
        ? round(value)
        : '-'
    },

    openCreateRationCopy () {
      this.modals.showCreateRationCopy = true
    },

    closeCreateRationCopy () {
      this.modals.showCreateRationCopy = false
    },

    openScheduleUploadDialog () {
      this.showScheduleUploadDialog = true
    },

    closeScheduleUploadDialog () {
      this.showScheduleUploadDialog = false
    },

    closeScheduleLoadDialog () {
      this.showScheduleLoadDialog = false
    },

    openScheduleLoadDialog () {
      this.showScheduleLoadDialog = true
    },
    onUpdate (group) {
      this.$emit('on-update-coefficient', group)
    },
  },

  watch: {
    'mixer.id': function (newValue, oldValue) {
      const existingMixer = this.mixers.find(mixer => mixer.id === newValue)

      if (oldValue !== '' && existingMixer) {
        this.mixer.name = existingMixer.name
        this.mixer.id = existingMixer.id
        const payload = {
          mixer: existingMixer.id,
          name: existingMixer.name
        }
        this.item.schedule_mixer = payload
        this.update()
      }
    },

    'ration.id': function (newValue, oldValue) {
      const existingRation = this.rationsList.find(ration => ration.id === newValue)
      if (oldValue !== '' && existingRation) {
        this.ration.id = existingRation.id
        this.ration.name = existingRation.name
        const payload = {
          ration: existingRation.id,
          name: existingRation.name,
        }
        this.item.schedule_ration = payload
        this.update()
      }
    },

    hasChanges (value) {
      if (value) {
        this.update()
      }
    }
  }
}
</script>


<style scoped>
.input-number {
    width: auto;
    max-width: 9rem;
    padding: .5rem;
    text-align: right;
    background-color: #F4F4F4;
    font-weight: 700;
    border-bottom: 1px solid #D8D8D8;
}
.leftovers-mark-icon{
  max-width: 35px;
    height: 24px;
    transform: scale(0.8);
}
</style>